@if (!isGuest && !companyRolesLoading && isLoggedIn) {
  <ng-content select="[slot][content]"></ng-content>
}
@if (!isGuest && !companyRolesLoading && isLoggedIn && (notForViewer && !isViewer)) {
  <ng-content select="[slot][nonViewerContent]"></ng-content>
}
@if (isGuest && description && !companyRolesLoading) {
  <p class="no-access">{{ 'customer.no-permission' | translate }}</p>
}
@if ((notForViewer && isViewer) && description && !companyRolesLoading) {
  <p class="no-access">{{ 'customer.no-permission' | translate }}</p>
}
